module.exports = __webpack_public_path__ + "static/media/sort-up.9baf8690.svg";